/**
 * @file 车型选择页面
 */

import React, {Component} from 'react';
import {WingBlank, NavBar, Icon, List, Calendar, Button, Toast} from 'antd-mobile';
import NavBarComponent from '../../component/common/NavBarComponent';
import * as Order from '../../redux/actions/orderAction'
import CarSearch from '../../component/carSearch/index';
import {Http, urls} from '../../api/index';
import {connect} from 'react-redux';
import {parseSearchToState, parseStateToSearch} from '../../util/util';

import './index.scss';

class CarList extends Component {
    constructor(props) {
        super(props);

        props.cacheLifecycles.didCache(this.componentDidCache);
        props.cacheLifecycles.didRecover(this.componentDidRecover);

        const {location} = this.props;
        const search = location.search;
        let {
            hourExceedsThresholdToOneDay,
            gaiCityId,
            getCityId,
            gaiCityName,
            getCityName,
            gaiStoreId,
            getStoreId,
            gaiStoreName,
            getStoreName,
            gaicoordinatePoint,
            getcoordinatePoint,
            startTime,
            endTime,
            sTime,
            eTime,
            dateDiffNum
        } = parseSearchToState(search);
        this.state = {
            hourExceedsThresholdToOneDay,
            gaiCityId,
            getCityId,
            gaiCityName,
            getCityName,
            gaiStoreId,
            getStoreId,
            gaiStoreName,
            getStoreName,
            gaicoordinatePoint,
            getcoordinatePoint,
            startTime,
            endTime,
            sTime,
            eTime,
            dateDiffNum,
            levelId: '',
            CarLevelList: [],
            carModelList: [],
            activeIndex: 0,
            isShowNodata: false,
            isOpenSearchBox: false,
            from: ''
        };
    }

    componentDidMount() {
        this.getCarLevelList();
    }

    componentDidCache = () => {
        this.setState({
            isOpenSearchBox: false
        });
    }
    
    componentDidRecover = () => {
        this.getUrlParams();
    }

    getUrlParams() {
        let self = this;
        const params = parseSearchToState(self.props.history.location.search);
        const {from} = params;
        this.setState({
            ...params,
            isOpenSearchBox: from ? true : false
        });
    }

    getCarLevelList() {
        let url = urls.getCarLevelList;
        let {
            gaiCityId,
            gaiStoreId,
            sTime,
            eTime
        } = this.state;
        let params = {
            cityId: gaiCityId,
            storeId: gaiStoreId,
            bookingGaincarTime: decodeURI(sTime),
            bookingBackcarTime: decodeURI(eTime),
            packageType: 'D'
        };
        this.setState({
            isShowNodata: false
        });
        Http.post({url, data: params}).then(res => {
            if (res.data.length > 0) {
                this.setState({
                    CarLevelList: res.data,
                    isShowNodata: res.data.length > 0 ? false : true
                });
                this.getModelList(res.data[0].levelId);
            } else {
                this.setState({
                    isShowNodata: res.data.length > 0 ? false : true
                });
            }
        });
    }

    getModelList(levelId) {
        let url = urls.getStockVehicleList;
        this.setState({
            levelId
        });
        let {
            gaiCityId,
            gaiStoreId,
            sTime,
            eTime
        } = this.state;
        let params = {
            levelId: levelId,
            cityId: gaiCityId,
            storeId: gaiStoreId,
            bookingGaincarTime: decodeURI(sTime),
            bookingBackcarTime: decodeURI(eTime),
            packageType: 'D'
        };
        Http.post({url, data: params}).then(res => {
            if (res.code === 0) {
                this.setState({
                    carModelList: res.data ? res.data : []
                });
            }
        });
    }

    updateStoreList(item, index) {
        this.setState({
            activeIndex: index
        });
        this.getModelList(item.levelId);
    }

    onOpenChange() {
        if (!sessionStorage.getItem('gaiCityInfo')) {
            Toast.fail('参数获取失败！', 2, () => {
                this.goHome('refresh');
            });
            return false;
        }
        this.setState({isOpenSearchBox: !this.state.isOpenSearchBox});
    }

    getDateDiffNum() {
        let {startTime, endTime} = this.props;
        let sTime = `${startTime.year}/${startTime.month}/${startTime.day} ${startTime.hours}:${startTime.minutes}`;
        let eTime = `${endTime.year}/${endTime.month}/${endTime.day} ${endTime.hours}:${endTime.minutes}`;
        let date1 = new Date(sTime);
        let date2 = new Date(eTime);
        let date = (date2.getTime() - date1.getTime()) / (1000 * 60 * 60);
        
        let num = date % 24 < 4 ? 0 : 1;
        date = parseInt(date / 24) + num;

        this.setState({
            dateDiffNum: date
        });
    }

    updaDate = () => {
        setTimeout(() => {
            let {
                gaiStoreInfo,
                getStoreInfo,
                startTime,
                endTime
            } = this.props;
            this.setState({
                gaiStoreName: gaiStoreInfo.storeName,
                getStoreName: getStoreInfo.storeName,
                gaiCityId: gaiStoreInfo.cityId,
                gaiStoreId: gaiStoreInfo.storeId,
                getCityId: getStoreInfo.cityId,
                gaiCityName: gaiStoreInfo.cityName,
                getCityName: getStoreInfo.cityName,
                getStoreId: getStoreInfo.storeId,
                gaicoordinatePoint: `${gaiStoreInfo.longitude},${gaiStoreInfo.latitude}`,
                getcoordinatePoint: `${getStoreInfo.longitude},${getStoreInfo.latitude}`,
                sTime: `${startTime.year}-${this.pad(startTime.month)}-${this.pad(startTime.day)} ${this.pad(startTime.hours)}:${this.pad(startTime.minutes)}:00`,
                eTime: `${endTime.year}-${this.pad(endTime.month)}-${this.pad(endTime.day)} ${this.pad(endTime.hours)}:${this.pad(endTime.minutes)}:00`,
                startTime: `${startTime.month}-${startTime.day} ${this.pad(startTime.hours)}:${this.pad(startTime.minutes)}`,
                endTime: `${endTime.month}-${endTime.day} ${this.pad(endTime.hours)}:${this.pad(endTime.minutes)}`,
                activeIndex: 0
            });
            this.onOpenChange();
            this.getDateDiffNum();
            this.getCarLevelList();
        }, 0);
    }

    pad = time => time >= 10 ? time : `0${time}`;

    goHome(isRefresh) {
        const {history} = this.props;
        history.push({
            pathname: '/',
            search: parseStateToSearch({isRefresh})
        });
    }

    handleStore(count, item) {
        const {history} = this.props;
        const {
            gaiCityId,
            getCityId,
            gaiCityName,
            getCityName,
            gaiStoreId,
            getStoreId,
            gaiStoreName,
            getStoreName,
            gaicoordinatePoint,
            getcoordinatePoint,
            startTime,
            endTime,
            sTime,
            eTime,
            dateDiffNum,
            levelId
        } = this.state;
        const {modelId, modelName, pictureUrl, gearboxType, outputVolume, passengerCount} = item;
        const params = {
            // 还车城市id
            backCityId: getCityId,
            // 还车城市名称
            backCityName: getCityName,
            // 还车门店id
            backStoreId: getStoreId,
            // 还车门店名称
            backStoreName: getStoreName,
            // 还车门店坐标
            backStorePoint: getcoordinatePoint,
            // 还车时间 格式： yyyyMMddHHmmss
            bookingBackcarTime: decodeURI(eTime),
            // 取车时间 格式： yyyyMMddHHmmss
            bookingGaincarTime: decodeURI(sTime),
            // 相差时间
            dateDiffNum: dateDiffNum,
            // 取车城市id
            gaiCityId: gaiCityId,
            // 取车城市名称
            gaiCityName: gaiCityName,
            // 取车门店id
            gaiStoreId: gaiStoreId,
            // 取车门店名称
            gaiStoreName: gaiStoreName,
            // 取车门店坐标
            gaiStorePoint: gaicoordinatePoint,
            // 预定车型ID
            bookingCarmodelId: modelId,
            // 车级id
            bookingCarGradeId: levelId,
            // 列表图片 pictureUrl
            pictureUrl: pictureUrl,
            // 列表车型名称 modelName
            modelName: modelName,
            // 列表车 gearboxType
            gearboxType: gearboxType,
            // 列表车 outputVolume
            outputVolume: outputVolume,
            // 列表车 passengerCount
            passengerCount: passengerCount
        };
        // 有车 去确认订单页面
        if (count > 0) {
            this.toOrderPage(params);
        }
        // 没车 去更换同城门店页面
        else {
            history.push({
                pathname: '/shopChange',
                search: parseStateToSearch({...params})
            });
        }
    }

    toOrderPage(params) {
        const {history} = this.props;
        let url = urls.makeShortOrderCheck;
        let {
            bookingCarmodelId,
            backStoreId,
            bookingBackcarTime,
            bookingGaincarTime,
            gaiStoreId
        } = params;
        let data = {
            bookingCarmodelId: bookingCarmodelId,
            bookingBackcarStoreId: backStoreId,
            bookingBackcarTimeStr: bookingBackcarTime.replace(/\-|\:|\s/g, ''),
            bookingGaincarStoreId: gaiStoreId,
            bookingGaincarTimeStr: bookingGaincarTime.replace(/\-|\:|\s/g, ''),
            orderProdType: 'D'
        };
        Http.post({url, data}).then(res => {
            history.push({
                pathname: '/order',
                search: parseStateToSearch({...params})
            });
        });
    }

    render() {
        let {
            gaiStoreName,
            getStoreName,
            startTime,
            endTime,
            dateDiffNum,
            CarLevelList,
            carModelList,
            activeIndex,
            isShowNodata,
            isOpenSearchBox
        } = this.state;
        return (
            <div className="car-list page">
                <NavBarComponent>
                        <NavBar
                            mode="light"
                            icon={ <Icon type="left" color="#333" /> }
                            leftContent=""
                            onLeftClick={ () => this.goHome() }
                            >
                                车型选择
                        </NavBar>
                    </NavBarComponent>
                <WingBlank>
                    <div className="gai-car shadow-box">
                        <div className="gai-car-address">
                            <p className="gai-car-storename">{decodeURI(gaiStoreName)}</p>
                            <p className="gai-car-time">{decodeURI(startTime)}</p>
                        </div>
                        <div className="gai-car-days">
                            <p className="days-con">{dateDiffNum}天</p>
                        </div>
                        <div className="gai-car-address">
                        <p className="gai-car-storename back-car-storename">{decodeURI(getStoreName)}</p>
                            <p className="gai-car-time">{decodeURI(endTime)}</p>
                        </div>
                        <div className="re-select-city" onClick={() => this.onOpenChange()}></div>
                    </div>
                </WingBlank>
                <div className="tabs-list shadow-box">
                {
                    this.state.CarLevelList.length === 0 ? null
                    : <div className="placeholder tabs-left">
                            {
                                CarLevelList.map((item, index) => {
                                    return (
                                        <div
                                            key={item.levelId}
                                            className="tabs-left-item"
                                            style={{backgroundColor: (index === activeIndex) ? '#fff' : '#F5F5F5'}}
                                            onClick={() => this.updateStoreList(item, index)}>
                                            <div className="tabs-nav-t">{item.levelName}</div>
                                            <div className="tabs-nav-p">￥{item.lowestPrice}起</div>
                                        </div>
                                    );
                                })
                            }
                        </div>
                }
                {
                    carModelList.length === 0 ? null
                    : <div className="placeholder tabs-right">
                        {
                            carModelList.map(item => {
                                return (
                                    <div
                                        key={item.modelId}
                                        onClick={() => this.handleStore(item.stockCount, item)}
                                        className={['store-item', item.stockCount > 0 ? '' : 'no-inventory'].join(' ')}>
                                        <div className="pics">
                                            {
                                                item.stockCount <= 0
                                                ? <div className="no-inventory-mask">
                                                    <p className="mask-title">已满租</p>
                                                    <p className="mask-des">更换门店 ></p>
                                                </div>
                                                : ''
                                            }
                                            <img className="thumb-img" src={item.pictureUrl}/>
                                        </div>
                                        <div className="car-info-con">
                                            <div className="titles"><p>{item.modelName}</p></div>
                                            <div className="des">
                                                <span>{item.gearboxType}</span>
                                                <span>{item.passengerCount}座</span>
                                                <span>{item.outputVolume}</span>
                                            </div>
                                            <div className="prices"><span>￥{item.averagePrice}</span>/日均</div>
                                        </div>
                                    </div>
                                );
                            })
                        }
                    </div>
                }
                {
                    isShowNodata
                    ? <div>
                        <div className="no-data"></div>
                        <div className="tips">该门店下暂无车辆</div>
                    </div>
                    : ''
                }
                </div>
                {
                    isOpenSearchBox
                    ? <div className="to-search">
                        <div className="mask" onClick={() => this.onOpenChange()}></div>
                        <CarSearch
                            callback={this.updaDate}
                            history={this.props.history}
                            fromPath={this.state.from}
                        ></CarSearch>
                    </div>
                    : ''
                }
            </div>
        );
    }
}

const mapStateToProps = state => {
    let params = state.homeReducer;
    return {
        gaiCityInfo: params.gaiCityInfo,
        getCityInfo: params.getCityInfo,
        gaiStoreInfo: params.gaiStoreInfo,
        getStoreInfo: params.getStoreInfo,
        startTime: params.startTime,
        endTime: params.endTime
    };
};

CarList = connect(mapStateToProps)(CarList);


export default CarList;
